import { FlexColumn } from '@editor/components/utilities/layouts';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { RadioDot } from '../utilities/RadioDot/styles';

export const VariationWrapper = styled(FlexColumn)<{ isActive: boolean }>`
  row-gap: 10px;

  border: 1px solid
    ${({ isActive }) =>
      isActive ? themeStyle.varSelectionBlue : themeStyle.varInkLight};
  background: ${({ isActive }) =>
    isActive ? themeStyle.varSelectionBlue10 : 'unset'};
  transition: border-color 0.3s;
  padding: 12px;
  border-radius: ${themeStyle.radiusMedium};
  cursor: pointer;

  &:hover {
    border-color: ${themeStyle.selectionBlue};

    ${RadioDot} {
      border-width: 3px;
      border-color: ${themeStyle.selectionBlue};
      background-color: ${themeStyle.varBackgroundAlt};
    }
  }
`;
